import React, { useReducer, createContext, useContext } from "react";

const MAX_PAGE_SIZE = 9999;
const INIT_PAGE_SIZE = 25;

const initialState = {
  workOrders: {},
  sizePerPage: INIT_PAGE_SIZE,
  page: 1,
  search: "",
  sortBy: "startDate",
  direction: "desc",
  statusId: null,
};

const ACTIONS = {
  SORT: "SORT",
  SEARCH: "SEARCH",
  REFRESH: "REFRESH",
  PAGE_CHANGE: "PAGE_CHANGE",
  PAGE_SIZE_CHANGE: "PAGE_SIZE_CHANGE",
  GET_WORKORDERS_SUCCESS: "GET_WORKORDERS_SUCCESS",
};

const reducer = (state, data) => {
  switch (data.action) {
    case ACTIONS.GET_WORKORDERS_SUCCESS: {
      const { payload } = data;
      const { workOrders, statusId } = payload;

      return {
        ...state,
        workOrders,
        statusId,
        page: statusId !== state.statusId ? 1 : state.page,
      };
    }

    case ACTIONS.SORT: {
      const { payload } = data;
      const { sortBy, direction } = payload;

      return {
        ...state,
        sortBy,
        direction,
        page: 1,
      };
    }

    case ACTIONS.SEARCH: {
      const { payload } = data;
      const { search } = payload;

      return {
        ...state,
        search,
        page: 1,
      };
    }

    case ACTIONS.REFRESH:
      return {
        ...state,
        refresh: !state.refresh,
      };

    case ACTIONS.PAGE_CHANGE: {
      const { payload } = data;
      const { page } = payload;
      return {
        ...state,
        page,
      };
    }

    case ACTIONS.PAGE_SIZE_CHANGE: {
      const { payload } = data;
      const { sizePerPage } = payload;
      return {
        ...state,
        sizePerPage,
        page: 1,
      };
    }

    default:
      throw new Error();
  }
};

const WorkOrdersContext = createContext(initialState);

const WorkOrdersProvider = ({ children }) => {
  const stateAndDispatch = useReducer(reducer, initialState);
  return (
    <WorkOrdersContext.Provider value={stateAndDispatch}>
      {children}
    </WorkOrdersContext.Provider>
  );
};

export const useWorkOrders = () => useContext(WorkOrdersContext);

export {
  WorkOrdersContext,
  WorkOrdersProvider,
  ACTIONS,
  MAX_PAGE_SIZE,
  INIT_PAGE_SIZE,
};
